import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = () => {
  const location = useLocation();
  const [seoSettings, setSeoSettings] = useState({
    meta_title: '',
    meta_description: '',
    meta_keywords: '',
  });

  useEffect(() => {
    fetchSEOSettings();
  }, []);

  useEffect(() => {
    updateMetaTags();
  }, [seoSettings, location.pathname]);

  const fetchSEOSettings = async () => {
    try {
      const response = await fetch('http://localhost/api/settings.php', {
        credentials: 'include',
      });
      
      if (response.ok) {
        const text = await response.text();
        const data = text ? JSON.parse(text) : {};
        
        setSeoSettings({
          meta_title: data.meta_title || 'Serpil Şahin Koleji',
          meta_description: data.meta_description || 'Serpil Şahin Koleji - Kaliteli Eğitim Anlayışı',
          meta_keywords: data.meta_keywords || 'kolej, eğitim, okul, malatya',
        });
      }
    } catch (error) {
      console.error('Error fetching SEO settings:', error);
    }
  };

  const updateMetaTags = () => {
    // Admin sayfalarında SEO ayarlarını uygulama
    const isAdminPage = location.pathname.startsWith('/admin') || location.pathname === '/sahinserpil4409';
    
    if (isAdminPage) {
      // Admin sayfalarında sabit title
      document.title = 'Serpil Şahin Yönetim Paneli';
      return;
    }

    // Normal sayfalarda SEO ayarlarını uygula
    // Title'ı güncelle
    if (seoSettings.meta_title) {
      document.title = seoSettings.meta_title;
    }

    // Meta description'ı güncelle veya oluştur
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    if (seoSettings.meta_description) {
      metaDescription.setAttribute('content', seoSettings.meta_description);
    }

    // Meta keywords'ü güncelle veya oluştur
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (seoSettings.meta_keywords) {
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.setAttribute('name', 'keywords');
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.setAttribute('content', seoSettings.meta_keywords);
    } else if (metaKeywords) {
      metaKeywords.remove();
    }
  };

  return null;
};

export default SEOHead;

